class ProductHotspots extends HTMLElement {
  constructor() {
    super();

    this.ZOOMED_CLASS = "product-hotspots__image--zoomed";
    this.HOTSPOT_ACTIVE_CLASS = "product-hotspots__hotspot--active";
    this.HOTSPOT_HIDDEN_CLASS = "product-hotspots__hotspot--hidden";

    this.hotspots = this.querySelectorAll("[data-hotspot]");
    this.isMobile = window.matchMedia("(max-width: 749px)").matches;
    this.hotspotsWrapper = this.querySelector("[data-hotspots-wrapper]");
    this.images = this.querySelectorAll("[data-hotspot-image]");
    this.drawer = document.querySelector("[data-hotspots-drawer]");
    this.currentX = 0;
    this.currentY = 0;

    this.addListener();
  }

  addListener() {
    this.hotspots.forEach((hotspot) => {
      hotspot.addEventListener("click", (event) => {
        this.panToHotspot(event.currentTarget);
      });
    });

    subscribe(PUB_SUB_EVENTS.drawerClosed, () => this.resetPan());
    subscribe(PUB_SUB_EVENTS.slideSelected, slide => {
      this.panToHotspot(this.hotspots[slide.index]);
    });
  }

  panToHotspot(hotspot) {
    const containerRect = this.getBoundingClientRect();
    const hotspotRect = hotspot.getBoundingClientRect();
    const drawerRect = this.drawer.getBoundingClientRect();

    this.addImageZoomClass();
    this.resetHotspotsActiveState();
    this.toggleHotspotsHiddenState("remove");
    this.toggleHotspotsHiddenState("add", hotspot);

    hotspot.classList.add(this.HOTSPOT_ACTIVE_CLASS);

    const hotspotCenterX = (hotspotRect.left - containerRect.left) + (hotspotRect.width / 2);
    const hotspotCenterY = (hotspotRect.top - containerRect.top) + (hotspotRect.height / 2);

    let containerCenterX = containerRect.width / 2;
    let containerCenterY = containerRect.height / 2;

    const offsetX = hotspotCenterX - containerCenterX;
    const offsetY = hotspotCenterY - containerCenterY;

    let newX = this.currentX - (offsetX);
    let newY = this.currentY - (offsetY);

    if (!this.isMobile) {
      const containerLeft = containerRect.left;
      const drawerLeft = drawerRect.left < window.innerWidth ? drawerRect.left : drawerRect.left - drawerRect.width;
      const midpoint = (containerLeft + drawerLeft) / 2;
      const hotspotCenterX = (hotspotRect.left - containerLeft) + (hotspotRect.width / 2);
      const offsetX = hotspotCenterX - (midpoint - containerLeft);

      newX = this.currentX - (offsetX);
    }

    if (this.isMobile) {
      newY += (drawerRect.top - containerRect.bottom) / 2;
    }

    this.hotspotsWrapper.style.transform = `translate(${newX}px, ${newY}px)`;

    this.currentX = newX;
    this.currentY = newY;
  }

  resetPan() {
    this.currentX = 0;
    this.currentY = 0;

    this.hotspotsWrapper.style.transform = `translate(0px, 0px)`;

    this.resetHotspotsActiveState();
    this.toggleHotspotsHiddenState("remove");
    this.addImageZoomClass("remove");
  }

  addImageZoomClass(action = "add") {
    this.images.forEach(image => image.classList[action](this.ZOOMED_CLASS));
  }

  resetHotspotsActiveState () {
    this.hotspots.forEach(hotspot => {
      hotspot.classList.remove(this.HOTSPOT_ACTIVE_CLASS);
    });
  }

  toggleHotspotsHiddenState(action, hotspotToExclude = null) {
    this.hotspots.forEach(hotspot => {
      if (hotspot === hotspotToExclude) return;

      hotspot.classList[action](this.HOTSPOT_HIDDEN_CLASS);
    });
  }
}

if (!customElements.get('product-hotspots')) {
  customElements.define('product-hotspots', ProductHotspots);
}
